import { z } from "zod";

export enum ExportFileKind {
	CONTACTS = "CONTACTS",
	COMPANIES = "COMPANIES",
}

export enum ExportFileStatus {
	PENDING = "PENDING",
	READY = "READY",
	FAILED = "FAILED",
	/** Was READY; the bytes have since been reaped. */
	EXPIRED = "EXPIRED",
}

/** Mirrors `ExportFileInfoDTO` (apps/api/src/export/dto/export-file-info.dto.ts). */
export const ExportFileInfoSchema = z.object({
	id: z.number(),
	kind: z.nativeEnum(ExportFileKind),
	status: z.nativeEnum(ExportFileStatus),
	fileName: z.string(),
	sizeBytes: z.number().nullable().optional(),
	rowCount: z.number().nullable().optional(),
	failureReason: z.string().nullable().optional(),
	expiresAt: z.union([z.string(), z.date()]).nullable().optional(),
	createdAt: z.union([z.string(), z.date()]).optional(),
});

export type ExportFileInfo = z.infer<typeof ExportFileInfoSchema>;
